export default "__VITE_ASSET__BvL0NQjo__"